<template>
  <div ref="rootRef" class="tags-view-container">
    <ScrollPane
      ref="scrollPane"
      class="tags-view-wrapper"
      @scroll="handleScroll"
    >
      <div
        v-for="(tag, idx) in tagdatas"
        :key="idx"
        ref="tag"
        @click.middle="!isAffix(tag) ? handleCloseSelectedTag(tag) : ''"
        @click="handleSelectTag(tag)"
        @contextmenu.prevent="handleOpenMenu(tag, $event)"
        :class="tag.show ? 'active' : ''"
        class="tags-view-item"
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
          "
        >
          <span class="tags-view-text">
            {{ tag.title }}
          </span>
        </div>
        <span
          v-if="!isAffix(tag)"
          class="iconfont icon-close closebtn"
          @click.prevent.stop="handleCloseSelectedTag(tag)"
        />
      </div>
    </ScrollPane>
    <ul
      v-show="visible"
      :style="{ left: left + 'px', top: top + 'px' }"
      class="contextmenu"
    >
      <li @click="handleRefreshSelectedTag(selectedTag)">刷新</li>
      <li
        v-if="!isAffix(selectedTag)"
        @click="handleCloseSelectedTag(selectedTag)"
      >
        关闭
      </li>
      <li @click="hanldeCloseRightTags(selectedTag)">关闭右边</li>
      <li @click="handleCloseAllTags">关闭所有</li>
    </ul>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import ScrollPane from "./ScrollPane.vue";

const props = defineProps(["tagdatas"]);
const emit = defineEmits([
  "closeSelectedTag",
  "selectTagEvent",
  "refreshSelectedTag",
  "closeRightTags",
  "closeAllTags",
]);

const visible = ref(false);
function handleCloseMenu() {
  visible.value = false;
}
watch(visible, (val) => {
  if (val) {
    document.addEventListener("click", handleCloseMenu);
  } else {
    document.removeEventListener("click", handleCloseMenu);
  }
});
function handleScroll() {
  handleCloseMenu();
}

function isAffix(tag) {
  return tag.affix;
}

const selectedTag = ref({});
function handleCloseSelectedTag(view) {
  emit("closeSelectedTag", view);
}
function handleSelectTag(tag) {
  emit("selectTagEvent", tag);
}
function handleRefreshSelectedTag(view) {
  emit("refreshSelectedTag", view);
}
function hanldeCloseRightTags(view) {
  emit("closeRightTags", view);
}
function handleCloseAllTags() {
  emit("closeAllTags");
}

const rootRef = ref(null);
const left = ref(0);
const top = ref(0);
function handleOpenMenu(tag, e) {
  const menuMinWidth = 105;
  const offsetWidth = rootRef.value.offsetWidth; // container width
  const maxLeft = offsetWidth - menuMinWidth; // left boundary
  const l = e.clientX + 5; // 15: margin right
  if (l > maxLeft) {
    left.value = maxLeft;
  } else {
    left.value = l;
  }
  top.value = e.clientY;
  visible.value = true;
  selectedTag.value = tag;
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 51px;
  width: 100%;
  margin-top: 2px;
  background: transparent;
  border-bottom: 1px solid #d8dce5;
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 50px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      vertical-align: middle;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        background-color: #66b1ff;
        color: #fff;
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}

.tags-view-text {
  display: inline-block;
  margin-right: 20px;
  max-width: 190px;
  word-break: break-all;
  align-content: normal;
  white-space: normal;
  line-height: normal;
  vertical-align: middle;
}

.closebtn {
  position: absolute;
  right: 4px;
  top: 4px;
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 50%;

      &:before {
        transform: scale(0.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        background-color: #b4bccc;
        color: #e51111;
      }
    }
  }
}
</style>
